import "./navbar.css";
import {
	ExitToApp,
	HomeOutlined,
	PermIdentity,
	PersonAddOutlined,
	Settings,
} from "@material-ui/icons";
import { NavLink, Link, useHistory } from "react-router-dom";
import { useCallback, useEffect } from "react";
import AuthService from "../../services/auth.service";
import { useContext } from "react";
import { AuthContext } from "../../context/AuthContext";


export default function Navbar() {
	const { user } = useContext(AuthContext);
	const history = useHistory();

	const logout = useCallback(async () => {
		await AuthService.logOut(history);
	}, [history]);

	useEffect(() => {
		if (!user) {
			history.replace("/");
			window.location.reload();
		}
	}, [user, history]);

	return (
		<div className="navbarContainer">
			<div className="navbar">
				<div className="navbarHeading">
					<span className="logo">ADMIN</span>
					<h3 className="navbarTitle">Dashboard</h3>
				</div>
				<div className="navbarMenu">
					<ul className="navbarList">
						<NavLink
							to={"/board/projects"}
							style={(isActive) => ({
								opacity: isActive ? "1" : "0.6",
							})}
							className="link"
						>
							<li className="navbarListItem">
								<HomeOutlined className="navbarIcon" />
								Home
							</li>
						</NavLink>
						<NavLink
							to={"/admin/users"}
							style={(isActive) => ({
								opacity: isActive ? "1" : "0.6",
							})}
							className="link"
						>
							<li className="navbarListItem">
								<PermIdentity className="navbarIcon" />
								Staff List
							</li>
						</NavLink>
						<NavLink
							to={"/admin/newUser"}
							style={(isActive) => ({
								opacity: isActive ? "1" : "0.6",
							})}
							className="link"
						>
							<li className="navbarListItem">
								<PersonAddOutlined className="navbarIcon" />
								Add Staff
							</li>
						</NavLink>
						<NavLink
							to={"/settings"}
							style={(isActive) => ({
								opacity: isActive ? "1" : "0.6",
							})}
							className="link"
						>
							<li className="navbarListItem">
								<Settings className="navbarIcon" />
								Settings
							</li>
						</NavLink>
						<Link
							to={"/"}
							style={{
								opacity: "0.8",
							}}
							className="link"
							onClick={logout}
						>
							<li className="navbarListItem">
								<ExitToApp className="navbarIcon" />
								Logout
							</li>
						</Link>
					</ul>
				</div>
			</div>
		</div>
	);
}
